// extracted by mini-css-extract-plugin
export default {"imageWrapper":"fJ-z","twoColumnImage":"gJ-z"};